import React from 'react';
import { connect } from 'react-redux';
import { ServiceForm } from 'triider-components';

import { Creators as FormCreators } from 'store/ducks/serviceForm';
import { getTriiderUser } from 'store/ducks/auth';
import { getCompany, getCompanyId } from 'store/ducks/company';

const Form = ({
  triiderUser,
  company,
  serviceId,
  tag,
  isOpen,
  isFormAddress,
  company_id,
  address,
  _onChange,
  _finishForm,
  _closeForm,
  loadingVisible,
  selectedAddress,
  companyObject,
}) => (
  <ServiceForm
    serviceId={serviceId}
    triiderUser={triiderUser}
    partner={company}
    tag={tag}
    theme="newPartner"
    // source={`${path}/${company.source}`}
    source={`${company.source}`}
    open={isOpen}
    isPartner
    isFormAddress={isFormAddress}
    address={address}
    close={_closeForm}
    onChange={_onChange}
    company_id={company_id}
    onFinish={_finishForm}
    loadingVisible={loadingVisible}
    selectedAddress={selectedAddress}
    isEnabledAddressIntegration={companyObject && companyObject.addresses_integration}
    disabledMatchAddress
  />
);

const mapStateToProps = state => ({
  triiderUser: getTriiderUser(state),
  company: getCompany(state),
  company_id: getCompanyId(state),
  companyObject: state.company.data,
  serviceId: state.serviceForm.serviceId,
  tag: state.serviceForm.tag,
  source: state.serviceForm.source,
  isOpen: state.serviceForm.isOpen,
  isFormAddress: state.serviceForm.isFormAddress,
  address: state.serviceForm.address,
  onFinish: state.serviceForm.onFinish,
  selectedAddress: state.serviceForm.selectedAddress,
  loadingVisible: state.ui.loaders.includes('SERVICE_FORM'),
});

const mapDispatchToProps = {
  _closeForm: FormCreators.closeForm,
  _onChange: FormCreators.changeForm,
  _finishForm: FormCreators.finishFormRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
